module.exports = __webpack_public_path__ + "img/ray-sigorta.f75e6eb9.jpg";